export default {
  club_name: 'Crowdia',
  club_name_short: 'crowdia',
  stadium_name: '',
  staging_url: 'https://crowdia.api.fangroup.io',
  prod_url: 'https://crowdia.api.fangroup.io',
  api: '/api',
  facebook: '',
  basename: '/crowdia',
  club_logo: '/assets/teams/crowdia.png',
  app_name: 'crowdia',
  websale_name: 'crowdia',
  ntb_team_id: 10062,
  microservice_url: 'https://stats.api.fangroup.io',
  currencyCaps: 'SEK',
  currencyShort: 'Kr',
  currencyShortSmall: 'kr',
  clubSportalityAvailable: false,
  leagueSportalityAvailable: false,
  cloudIdName: 'crowdia',
  monolithEnabled: false,
};
